import React, { useState, useEffect } from "react";
import { IzostanciDataTable } from "../components/IzostanciDataTable";
import UnauthorizedAccess from "../components/UnauthorizedAccess";
import InternalServerError from "../components/InternalServerError";

export const Izostanci = (props) => {
  const [restData, setRestData] = useState(null);
  const [fetchState, setFetchState] = useState(null);

  useEffect(() => {
    fetch(
      props.rest +
        sessionStorage.getItem("ustanova") +
        "&prema_obliku=" +
        sessionStorage.getItem("premaObliku") +
        "&godina_upisa=" +
        sessionStorage.getItem("godinaUpisa") +
        "&redni_broj=" +
        sessionStorage.getItem("redniBroj") +
        "&razred=" +
        sessionStorage.getItem("razredPregleda"),
      {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Authorization: sessionStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then((response) => {
        //console.log("Response izostanci: " + response);
        if (response.status === 200) {
          setFetchState(200);
          return response.json();
        } else if (response.status === 204) {
          setFetchState(204);
          return null;
        } else if (response.status === 401) {
          setFetchState(401);
          return null;
        } else if (response.status === 500) {
          setFetchState(500);
          return null;
        } else {
          return null;
        }
      })
      .then((data) => {
        //console.log("Data stringify test:" + JSON.stringify(data));
        setRestData(data);
      })
      .catch((err) => {
        //console.log("Error izostanci:" + err);
      });
  }, [props.rest]);

  return (
    <div>
      <p className="page-title">Izostanci za {sessionStorage.getItem("razredPregleda")}. razred</p>
      <div>
        {fetchState === 200 ? <IzostanciDataTable data={restData} /> : ""}
        {fetchState === 401 ? <UnauthorizedAccess /> : ""}
        {fetchState === 500 ? <InternalServerError /> : ""}
      </div>
    </div>
  );
};

export default Izostanci;
